import React, { ReactNode } from 'react';
interface FieldProps {
  label: string;
  value?: ReactNode;
  className?: string;
}
export function Field({
  label,
  value,
  className = ''
}: FieldProps) {
  const isEmpty = value === undefined || value === null || value === '';
  return <div className={className} data-id="element-761" data-mp="3var9drwqc5p3">
      <dt className="text-[11px] font-medium uppercase tracking-wider text-muted" data-id="element-762" data-mp="42wjvhvwtnkw">{label}</dt>
      <dd className={`mt-1 text-sm ${isEmpty ? 'text-slate-300' : 'text-slate-800'}`} data-id="element-763" data-mp="91pwz97abckj">{isEmpty ? '—' : value}</dd>
    </div>;
}